<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div class="table-wrapper">
      <b-table
        :busy="isLoading"
        head-variant="light"
        :no-local-sorting="true"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        per-page="0"
        :sticky-header="height"
        no-border-collapse
        responsive
        show-empty
        empty-text="Non ci sono informazioni da mostrare"
        small
      >
        <template #table-busy>
          <table-skeleton />
        </template>
        <template #empty>
          <template v-if="newLisacomunicaLogBtn">
            <div
              class="d-flex flex-column justify-content-center align-items-center my-3"
              style="max-width: max-content; margin-inline: auto"
            >
              <p class="mb-2">
                Effettua una ricerca oppure, se non trovi risultati, crea un
                nuovo Log cliccando sul pulsante qui sotto
              </p>
              <b-button
                class="btn-create px-3"
                type="button"
                variant="primary"
                size="sm"
                @click="onAddNewLisacomunicaLog"
                title="Crea"
                :disabled="!canVerb(resource, 'store')"
                style="max-width: max-content"
              >
                <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                Crea
              </b-button>
            </div>
          </template>
          <template v-else>
            <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
          </template>
        </template>
        <template #cell(procedure_id)="{ item, value }">
          <router-link
            v-if="
              item.procedure_id && canVerb('communication_procedures', 'index')
            "
            :to="{
              name: 'communication_procedures.index',
              query: { id: item.procedure_id },
            }"
            title="Apri la procedura"
            >{{ item.procedure_id }}</router-link
          >
          <span v-else>{{ value }}</span>
        </template>
        <template #cell(status)="{ item }">
          <status-badge
            kind="log"
            :status="{ value: item.status, text: mappedStatuses(item.status) }"
          />
        </template>
        <template #cell(actions)="row">
          <div class="action-buttons">
            <b-button
              size="sm"
              variant="lisaweb"
              @click="openModal(row.item, row.index, $event.target)"
              class="mt-1 mr-1"
              title="Modale Dettagli"
            >
              <base-icon name="eye" width="22"></base-icon>
            </b-button>
          </div>
        </template>
        <template #cell()="{ value }">
          <span>{{ value }}</span>
        </template>
      </b-table>
      <b-modal
        id="modal"
        size="xl"
        scrollable
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14" />
        </template>
        <div>
          <b-tabs
            nav-class="modal-tab-lisacomunica-log"
            content-class="pt-1 pb-4"
            lazy
            v-model="tabIndex"
          >
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              :title-item-class="['lisaweb', tab.itemClass]"
            >
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
                >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                  page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }}</span>
              </template>
              <template v-slot:first-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                  ><base-icon
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                  ><base-icon
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import template_lisaweb from "./template_lisaweb";
import BaseIcon from "@/components/BaseIcon";
import StatusBadge from "@/components/StatusBadge";
import General from "@/components/profile/lisacomunica/logs/details/General";
import EmptyTable from "@/components/EmptyTable.vue";
import BaseInputPagination from "../form/BaseInputPagination.vue";
import AutoRefreshMixin from "@/mixins/AutoRefreshMixin";

// stati in lavorazione: finché ce n'è uno in pagina la tabella si ricarica da sola
const ACTIVE_LOG_STATUSES = ["SCHEDULED"];

export default {
  name: "LisacomunicaLogTable",
  extends: template_lisaweb,
  mixins: [AutoRefreshMixin],
  data() {
    return {
      tabs: [
        { name: "General", text: "Generale", itemClass: "general-only-hide" },
      ],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
    };
  },
  methods: {
    mappedStatuses(s) {
      const found = this.status.find((_s) => _s.value === s);
      return found?.text ?? "-";
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewLisacomunicaLog() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    /* Aggiornamento dinamico (polling, AutoRefreshMixin) della pagina con log in lavorazione */
    hasActiveRows() {
      return this.items.some((item) => ACTIVE_LOG_STATUSES.includes(item.status));
    },
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      const perPage = Number(this.perPage) || 20;
      const from = (this.currentPage - 1) * perPage + 1;
      return from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      const perPage = Number(this.perPage) || 20;
      const to = Math.min(this.currentPage * perPage, this.totalItems);
      return to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  props: {
    status: {
      type: Array,
      default() {
        return [];
      },
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    newLisacomunicaLogBtn: {
      type: Boolean,
      default: false,
    },
    noPagination: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
    StatusBadge,
    BaseInputPagination,
    General,
    EmptyTable,
  },
};
</script>
